import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from '../button/button.module';
import { IconComponent } from '../icon/icon';

export type ErrorStateSize = 'sm' | 'md' | 'lg';

const sizes: Record<ErrorStateSize, string> = {
  sm: 'min-h-24',
  md: 'min-h-36',
  lg: 'min-h-48',
};

const defaultSize: ErrorStateSize = 'md';

@Component({
  selector: 'wma-error-state',
  templateUrl: 'error-state.html',
  imports: [ButtonModule, IconComponent, TranslatePipe],
  host: {
    role: 'alert',
    '[class]': 'hostClasses()',
  },
})
export class ErrorStateComponent {
  /** The minimum height of the error state. */
  size = input<ErrorStateSize>();
  /** The action triggered by the retry button. The button is displayed only when provided. */
  retry = input<() => void>();

  /* The CSS classname applied to the host element. */
  hostClasses = computed(() => {
    return `flex flex-col items-center justify-center text-center ${sizes[this.size() || defaultSize]}`;
  });
}
